module.exports = __webpack_public_path__ + "static/media/safewrd_logo.cdcfee29.svg";